import { build } from './base'

export default build('#0f6cd5', 'white')



// WEBPACK FOOTER //
// ./src/app/themes/light.js